//#region import /container/stat/** */
import DegerlemeToplamDegerApi from './container/stat/DegerlemeToplamDegerApi';
import GayrimenkulAlanApi from './container/stat/GayrimenkulAlanApi';
import GayrimenkulSayiApi from './container/stat/GayrimenkulSayiApi';
import GayrimenkulToplamDegerApi from './container/stat/GayrimenkulToplamDegerApi';
import KullanimAmacliGayrimenkulAlanApi from './container/stat/KullanimAmacliGayrimenkulAlanApi';
import KullanimAmacliGayrimenkulSayiApi from './container/stat/KullanimAmacliGayrimenkulSayiApi';
import KullanimAmacliGayrimenkulToplamDegerApi from './container/stat/KullanimAmacliGayrimenkulToplamDegerApi';
import OyakDegerlemeToplamDegerApi from './container/stat/OyakDegerlemeToplamDegerApi';
import OyakEmlakVergileriApi from './container/stat/OyakEmlakVergileri';
import OyakEmlakVergileriDetayToplamDegerApi from './container/stat/OyakEmlakVergileriDetayToplamDegerApi';
import OyakKiraTrGeneliAylikGelirDagilimiListeleApi from './container/stat/OyakKiraTrGeneliAylikGelirDagilimiListeleApi';
import OyakKiraTrGeneliYillikGelirDagilimiListeleApi from './container/stat/OyakKiraTrGeneliYillikGelirDagilimiListeleApi';
import YatirimAmacliGayrimenkulAlanApi from './container/stat/YatirimAmacliGayrimenkulAlanApi';
import YatirimAmacliGayrimenkulSayiApi from './container/stat/YatirimAmacliGayrimenkulSayiApi';
import YatirimAmacliGayrimenkulToplamDegerApi from './container/stat/YatirimAmacliGayrimenkulToplamDegerApi';
//#endregion
//#region import /container/user/** */
import KullaniciKontrolApi from './container/user/KullaniciKontrolApi';
import OtpAlApi from './container/user/OtpAlApi';
import OtpKontrolApi from './container/user/OtpKontrolApi';
import OturumAcApi from './container/user/OturumAcApi';
import OturumKapatApi from './container/user/OturumKapatApi';
import SifremiUnuttumApi from './container/user/SifremiUnuttumApi';
import SifreDegistirApi from './container/user/SifreDegistirApi';
import UiLogEkleApi from './container/user/UiLogEkleApi';
import UiVersionKontrolApi from './container/user/UiVersionKontrolApi';
//#endregion
//#region import /container/veri/** */
import GrupSirketListeleApi from './container/veri/GrupSirketListeleApi';
import HaritadaAraApi from './container/veri/HaritadaAraApi';
import ProjeListeleApi from './container/veri/ProjeListeleApi';
import SorguInputlariApi from './container/veri/SorguInputlariApi';
import RaporUrlGetirApi from './container/veri/RaporUrlGetirApi';
import FaaliyetAlaniListesiApi from './container/veri/FaaliyetAlaniListesiApi';
//#endregion
//#region import /container/bilgi/** */
import AnasayfaUstBilgiApi from './container/bilgi/AnasayfaUstBilgiApi';
import FaaliyetAlaniUstBilgiApi from './container/bilgi/FaaliyetAlaniUstBilgiApi';
import GrupSirketDegerlemeUstBilgiApi from './container/bilgi/GrupSirketDegerlemeUstBilgiApi';
import GrupSirketiUstBilgiApi from './container/bilgi/GrupSirketiUstBilgiApi';
import KiraBilgiApi from './container/bilgi/KiraBilgiApi';
import KiraGenelBilgiApi from './container/bilgi/KiraGenelBilgiApi';
import MadenSahalariBilgiApi from './container/bilgi/MadenSahalariBilgiApi';
import MadenSahalariGenelBilgiApi from './container/bilgi/MadenSahalariGenelBilgiApi';
import OyakDegerlemeUstBilgiApi from './container/bilgi/OyakDegerlemeUstBilgiApi';
import OyakGmCiroBazliApi from './container/bilgi/OyakGmCiroBazliApi';
import OyakKiraBilgileriUstBilgiAkgDetayApi from './container/bilgi/OyakKiraBilgileriUstBilgiAkgDetayApi';
import OyakKiraBilgileriUstBilgiApi from './container/bilgi/OyakKiraBilgileriUstBilgiApi';
import OyakKiraBilgileriUstBilgiKvtDetayApi from './container/bilgi/OyakKiraBilgileriUstBilgiKvtDetayApi';
import OyakKiraBilgileriUstBilgiYkgDetayApi from './container/bilgi/OyakKiraBilgileriUstBilgiYkgDetayApi';
import OyakKiraTrGeneliKirayaVerilenTasinmazlarApi from './container/bilgi/OyakKiraTrGeneliKirayaVerilenTasinmazlarApi';
import OyakProjeToplamHakedisApi from './container/bilgi/OyakProjeToplamHakedisApi';
import SorgulamaSonuclariApi from './container/bilgi/SorgulamaSonuclariApi';
import TiklamaSonuclariApi from './container/bilgi/TiklamaSonuclari';
import UstBilgiIstatistikDetayApi from './container/bilgi/UstBilgiIstatistikDetayApi';
import YurtDisiTasinmazlariBilgiApi from './container/bilgi/YurtDisiTasinmazBilgiApi';
import YurtDisiTasinmazlariGenelBilgiApi from './container/bilgi/YurtDisiTasinmazGenelBilgiApi';
//#endregion
//#region import /container/harita/** */
import GetirParselGeoJsonApi from './container/harita/GetirParselGeoJsonApi';
//#endregion
//#region import /container/rapor/** */
import SirketBazliKiraIcmalRaporApi from './container/rapor/SirketBazliKiraIcmalRaporApi';
import KiraIcmalRaporApi from './container/rapor/KiraIcmalRaporApi';
import YurtDisiTasinmazIcmalRaporApi from './container/rapor/YurtDisiTasinmazIcmalRaporApi';
import SirketBazliYurtDisiTasinmazRaporApi from './container/rapor/SirketBazliYurtDisiTasinmazRaporApi';
//#endregion
export default {
  User: {
    KullaniciKontrol: KullaniciKontrolApi,
    OtpAl: OtpAlApi,
    OtpKontrol: OtpKontrolApi,
    OturumAc: OturumAcApi,
    OturumKapat: OturumKapatApi,
    SifremiUnuttum: SifremiUnuttumApi,
    SifreDegistir: SifreDegistirApi,
    UiLogEkle: UiLogEkleApi,
    UiVersionKontrol: UiVersionKontrolApi
  },
  Veri: {
    GrupSirketListele: GrupSirketListeleApi,
    FaaliyetAlaniListesi: FaaliyetAlaniListesiApi,
    HaritadaAra: HaritadaAraApi,
    ProjeListele: ProjeListeleApi,
    SorguInputlari: SorguInputlariApi,
    RaporUrlGetir: RaporUrlGetirApi,
  },
  Bilgi: {
    Anasayfa: AnasayfaUstBilgiApi,
    FaaliyetAlani: FaaliyetAlaniUstBilgiApi,
    GrupSirketDegerlemeUstBilgi: GrupSirketDegerlemeUstBilgiApi,
    GrupSirketi: GrupSirketiUstBilgiApi,
    KiraBilgi: KiraBilgiApi,
    KiraGenelBilgi: KiraGenelBilgiApi,
    MadenSahalariBilgi: MadenSahalariBilgiApi,
    MadenSahalariGenelBilgi: MadenSahalariGenelBilgiApi,
    OyakDegerlemeUstBilgi: OyakDegerlemeUstBilgiApi,
    OyakGmCiroBazliListe: OyakGmCiroBazliApi,
    OyakKiraBilgileriUstBilgiAkgDetay: OyakKiraBilgileriUstBilgiAkgDetayApi,
    OyakKiraBilgileriUstBilgi: OyakKiraBilgileriUstBilgiApi,
    OyakKiraBilgileriUstBilgiKvtDetay: OyakKiraBilgileriUstBilgiKvtDetayApi,
    OyakKiraBilgileriUstBilgiYkgDetay: OyakKiraBilgileriUstBilgiYkgDetayApi,
    OyakKiraTrGeneliKirayaVerilenTasinmazlar: OyakKiraTrGeneliKirayaVerilenTasinmazlarApi,
    OyakProjeToplamHakedisListe: OyakProjeToplamHakedisApi,
    SorgulamaSonuclariListe: SorgulamaSonuclariApi,
    TiklamaSonuclariListe: TiklamaSonuclariApi,
    UstBilgiIstatistikDetayApi: UstBilgiIstatistikDetayApi,
    YurtDisiTasinmazlariBilgi: YurtDisiTasinmazlariBilgiApi,
    YurtDisiTasinmazlariGenelBilgi: YurtDisiTasinmazlariGenelBilgiApi,
  },
  Stat: {
    GayrimenkulToplamDeger: {
      KullanimAmacli: KullanimAmacliGayrimenkulToplamDegerApi,
      YatirimAmacli: YatirimAmacliGayrimenkulToplamDegerApi,
      Toplam: GayrimenkulToplamDegerApi,
    },
    GayrimenkulAlan: {
      KullanimAmacli: KullanimAmacliGayrimenkulAlanApi,
      YatirimAmacli: YatirimAmacliGayrimenkulAlanApi,
      Toplam: GayrimenkulAlanApi,
    },
    GayrimenkulSayi: {
      KullanimAmacli: KullanimAmacliGayrimenkulSayiApi,
      YatirimAmacli: YatirimAmacliGayrimenkulSayiApi,
      Toplam: GayrimenkulSayiApi,
    },
    Degerleme: {
      Toplam: DegerlemeToplamDegerApi,
    },
    OyakDegerleme: {
      Toplam: OyakDegerlemeToplamDegerApi,
    },
    OyakEmlakVergiler: OyakEmlakVergileriApi,
    OyakEmlakVergileriDetayToplamDeger: OyakEmlakVergileriDetayToplamDegerApi,
    OyakKiraTrGeneliYillikGelirDagilimiListele: OyakKiraTrGeneliYillikGelirDagilimiListeleApi,
    OyakKiraTrGeneliAylikGelirDagilimiListele: OyakKiraTrGeneliAylikGelirDagilimiListeleApi,
  },
  Harita: {
    GetirParselGeoJson: GetirParselGeoJsonApi,
  },
  Rapor: {
    SirketBazliKiraIcmalRapor: SirketBazliKiraIcmalRaporApi,
    KiraIcmalRapor: KiraIcmalRaporApi,
    SirketBazliYurtDisiTasinmazRapor: SirketBazliYurtDisiTasinmazRaporApi,
    YurtDisiTasinmazIcmalRapor: YurtDisiTasinmazIcmalRaporApi,
  },
};
